import Socket from './src/Socket';
import ServerRequest from './src/ServerRequest';
import EventBus from './src/EventBus';

export const VueSocket = Socket;
export const VueServerRequest = ServerRequest;
export const VueEventBus = EventBus;

export default {
    VueSocket: Socket,
    VueServerRequest: ServerRequest,
    VueEventBus: EventBus
};
